import * as actionTypes from "./actionTypes";

export const reducer = (state, action) => {
  const payload = action.payload;
  switch (action.type) {
    case actionTypes.ADDED_VERIFICATIONS: {
      return { ...state, addedVerifications: payload.addedVerifications };
    }
    case actionTypes.VERIFICATION_ENTITY: {
      return { ...state, verificationEntity: payload.verificationEntity };
    }
    case actionTypes.VERIFICATIONS_TO_LAUNCH: {
      return { ...state, verificationsToLaunch: payload.verificationsToLaunch };
    }
    case actionTypes.INTERNAL_VERIFICATIONS: {
      return { ...state, internalVerifications: payload.internalVerifications };
    }
    case actionTypes.INTERNAL_VERIFICATIONS_ON_PAGE: {
      return { ...state, internalVerificationsOnPage: payload.internalVerificationsOnPage };
    }
    case actionTypes.PAGER: {
      return { ...state, pager: payload.pager };
    }
    case actionTypes.TOTAL_COUNT: {
      return { ...state, totalCount: payload.totalCount };
    }
    case actionTypes.FILTER: {
      return { ...state, filter: payload.filter };
    }
    case actionTypes.CURRENT_ENTITIES: {
      return { ...state, currentEntities: payload.currentEntities };
    }
    default:
      return state;
  }
};
